import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-hourglass-progress",
  templateUrl: "./med-icon-hourglass-progress.component.html",
})
export class MedIconHourglassProgressComponent extends SvgMixinComponent {}
